/*
 * @Author: git config zhang && 10899060+inheaven98@user.noreply.gitee.com
 * @Date: 2024-03-15 16:13:46
 * @LastEditors: inHeaven98 10899060+inheaven98@user.noreply.gitee.com
 * @LastEditTime: 2024-05-07 09:31:20
 * @FilePath: \cei-saas-platform\src\utils\auth.js
 * @Description:
 *
 * Copyright (c) 2024 by ${git_name_email}, All Rights Reserved.
 */
import Cookies from 'js-cookie'

const TokenKey = 'admin-token'
// const TokenKey = 'Editor-token'

export function getToken() {
	return Cookies.get(TokenKey)
}

export function setToken(token) {
	return Cookies.set(TokenKey, token)
}

export function removeToken() {
	return Cookies.remove(TokenKey)
}

export function remberPass(obj) {
	return Cookies.set('memory', obj)
}

export function getMemory() {
	return Cookies.get('memory')
}

// export function getToken() {
// 	return localStorage.getItem(TokenKey)
// }

// export function setToken(token) {
// 	return localStorage.setItem(TokenKey, token)
// }

// export function removeToken() {
// 	return localStorage.removeItem(TokenKey)
// }
// export function remberPass(obj) {
// 	return localStorage.setItem('memory', obj)
// }

// export function getMemory() {
// 	return localStorage.getItem('memory')
// }
